/** User shell + list cards (competitions, fashion designer). */
export const SITE_PAGE_BG = "#242743";
export const SITE_BORDER = "#414466";

/** Same as page shell — list rows/cards sit flush with `#242743` layout. */
export const LIST_CARD_BG = SITE_PAGE_BG;
export const LIST_CARD_BG_HOVER = "#2c3054";
export const LIST_MEDIA_BG = "#1b1e36";
const LIST_GRADIENT_END = SITE_PAGE_BG;

export function listRowBackground({ isFirst, isTop3, hovered }) {
  if (isFirst) {
    return `linear-gradient(90deg, rgba(240,199,94,0.14) 0%, ${LIST_GRADIENT_END} 55%)`;
  }
  if (isTop3) {
    return `linear-gradient(90deg, rgba(232,196,168,0.1) 0%, ${LIST_GRADIENT_END} 50%)`;
  }
  if (hovered) return LIST_CARD_BG_HOVER;
  return LIST_CARD_BG;
}

export function listRowBorderColor({ isFirst, isTop3, hovered }) {
  if (isFirst) return "rgba(240,199,94,0.55)";
  if (isTop3) return "rgba(232,196,168,0.4)";
  if (hovered) return "rgba(239,54,78,0.45)";
  return SITE_BORDER;
}

export const listCardSx = {
  bgcolor: LIST_CARD_BG,
  border: `1px solid ${SITE_BORDER}`,
};
